import { schema } from 'normalizr';

const idToString = {
  idAttribute: (obj: any) => obj.id?.toString(),
};

export const channel = new schema.Entity('channels', {}, idToString);

export const discussion = new schema.Entity('discussions', {}, idToString);

export const comment = new schema.Entity('comments', {}, idToString);

channel.define({
  discussions: [discussion],
});

discussion.define({
  channel,
  comments: [comment],
});

comment.define({
  discussion,
  quotedComment: comment,
  replies: [comment],
});
